export default {"src":"/_next/static/media/connect-to-discord.f8e20ce2.svg","height":105,"width":262};